module.exports = __webpack_public_path__ + "media/new_shopper_bonus/lock@2x-2e3715e5.png";